export enum LogEventLevel {
    Information = 'info',
    Warning = 'warn',
    Error = 'error',
    Fatal = 'fatal',
    Debug = 'debug',
    Trace = 'trace',
}
